<template>
    <div class="package-down">
        <div class="title">
            <div class="title-name">
                <div :class="[item.title.release ? 'release': '']">{{item.title.cname}}<strong>{{item.title.version}}</strong></div>
            </div>
            <div class="title-desc">{{item.title.desc}}</div>
        </div>
        <div class="basic">
            <div class="basic-head">
                <div class="basic-head-tag"></div>
                <div class="basic-head-name">{{item.basic.name}}</div>
                <div v-if="isBinary" class="basic-head-item">大小：{{item.basic.size}}</div>
                <div v-if="isBinary" class="basic-head-item">MD5：{{item.basic.md5}}</div>
                <div class="basic-head-desc">{{item.basic.desc}}</div>
                <div class="basic-head-log" @click="jumpPage(item.basic.extra_info.log)">，更新日志<i style="color: #3A84FF; font-size: 14px;margin-left: 8px;" class="icon-cc-jump-link-2"></i></div>
                <div class="basic-head-btn">
                    <template v-if="type === 'binary'">
                        <div class="btn basic-head-download" @click="basicJumpPage(item.basic, '立即下载')">立即下载</div>
                        <div class="btn basic-head-install" @click="basicJumpPage(item.basic, '安装指引')">安装指引</div>
                    </template>
                    <div v-else class="btn combo-deploy" @click="basicJumpPage(item.basic, '前往部署')">前往部署</div>
                </div>
            </div>
            <div class="basic-content">
                <contentVue :list="item.basic.children" :is-basic="true"></contentVue>
            </div>
        </div>
        <div class="va">
            <div class="va-icon r1"></div>
            <div class="va-icon r1 rr"></div>
            <span style="padding: 0 15px">增值套餐</span>
            <div class="va-icon r2 ll"></div>
            <div class="va-icon r2"></div>
        </div>
        <div class="annotation">以下套餐的资源配置建议，是指在基础套餐最少资源配置之外的另需资源；如有大规模生产投入及高可用规划，需要根据实际使用情况进行扩容。</div>
        <div class="combos">
            <div class="combo-item" v-for="combo in item.combos" :key="combo.name">
                <div class="combo-name">
                    {{combo.name}}
                    <img v-if="combo.name === '容器管理套餐' && type === 'containerize'" class="combo-tag" src="../../images/downloads/must.png" alt="">
                    <img v-else class="combo-tag" src="../../images/downloads/optional.png" alt="">
                </div>
                <div class="combo-desc">
                    <div v-if="isBinary" class="combo-desc-item">大小：{{combo.extra_info.size}}</div>
                    <div v-if="isBinary" class="combo-desc-item">MD5：{{combo.extra_info.md5}}</div>
                    <p class="combo-desc-item">{{combo.desc}}，更新日志<i @click="jumpPage(combo.extra_info.log)" style="color: #3A84FF; font-size: 14px;margin-left: 8px;" class="icon-cc-jump-link-2 link"></i></p>
                </div>
                <div class="combo-ctr">
                    <contentVue
                        :ref="combo.name"
                        style="width: 100%;height: 100%;"
                        :list="combo.children"
                        :comboType="combo.name === '容器管理套餐'"
                        @recordUserDownload="recordUserDownload"
                        @containerDeployValidate="containerDeployValidate">
                    </contentVue>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import binary from './binary.vue';
import contentVue from './content.vue';
export default {
    name: 'packageDown',
    components: {
        binary,
        contentVue
    },
    props: {
        type: String,
        item: Object
    },
    data () {
        return {
            info: {
                title: {},
                basic: {}, // 基础套餐
                combos: [] // 增值套餐
            }
        }
    },
    computed: {
        isBinary () {
            return this.type === 'binary'
        },
        isLogin () {
            return this.$store.state.isLogin
        }
    },
    mounted () {
    },
    methods: {
        recordUserDownload (cur) {
            this.$emit('recordUserDownload', cur)
        },
        containerDeployValidate (cur) {
            this.$emit('containerDeployValidate', cur)
        },
        basicJumpPage (basic, type) {
            const cur = basic.children.find(i => i.name === type)
            if (type === '立即下载') {
                this.$emit('recordUserDownload', cur)
                return
            } else if (type === '前往部署') {
                this.$emit('containerDeployValidate', cur)
            } else {
                window.open(cur.url,"_blank")
            }

        },
        // 更新日志跳转
        jumpPage (url) {
            if (url) {
                window.open(url,"_blank")
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.link {
    cursor: pointer;
}
.package-down {
    width: 1200px;
    margin: 0 auto;
    .title {
        width: 1200px;
        height: 42px;
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10);
        border-radius: 2px;
        padding: 0 21px;
        line-height: 42px;
        margin-bottom: 18px;
        .title-name {
            width: 250px;
            height: 42px;
            float: left;
            position: relative;
            .release {
                &::after {
                    position: absolute;
                    content: 'Release';
                    top: 0px;
                    right: 25px;
                    height: 18px;
                    background: #e4faf0;
                    color: #11a466;
                    border-radius: 2px;
                    line-height: 18px;
                    font-size: 12px;
                    text-align: center;
                    font-weight: bold;
                    padding: 0 2px;
                }
            }
        }
        .title-desc {
            float: left;
        }
    }
    .basic {
        width: 100%;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10);
        border-radius: 2px;
        .basic-head {
            width: 1200px;
            height: 68px;
            background-image: linear-gradient(90deg, #F9F9FB 1%, #E7E8EC 73%);
            border-radius: 2px;
            position: relative;
            line-height: 68px;
            overflow: hidden;
            .basic-head-tag {
                position: absolute;
                width: 61px;
                height: 51px;
                top: -4px;
                left: -6px;
                background: url('../../images/downloads/must.png');
            }
            .basic-head-name {
                margin-left: 41px;
                width: 200px;
                height: 68px;
                font-weight: Bold;
                font-size: 18px;
                color: #313238;
                position: relative;
                float: left;
                .basic-head-tag {
                    width: 100px;
                    height: 20px;
                    position: absolute;
                    font-size: 12px;
                    color: #63656E;
                    float: left;;
                }
            }
            .basic-head-desc {
                font-size: 12px;
                color: #63656E;
                float: left;;
            }
            .basic-head-item {
                margin-right: 41px;
                font-size: 12px;
                float: left;
            }
            .basic-head-log {
                font-size: 12px;
                color: #63656E;
                float: left;;
                cursor: pointer;
            }
            .basic-head-btn {
                display: flex;
                float: right;
                padding: 17px 0;
                .btn {
                    width: 120px;
                    height: 32px;
                    background: #3A84FF;
                    border: 1px solid #3A84FF;
                    color: #fff;
                    margin-right: 8px;
                    border-radius: 2px;
                }
                .basic-head-download, .combo-deploy {
                    &:hover {
                        opacity: 0.7;
                    }
                }
                .basic-head-install {
                    color: #63656e;
                    background: #ffffff;
                    border: 1px solid #c4c6cc;
                    border-radius: 3px;
                    &:hover {
                        border: 1px solid #979ba5;
                        // opacity: 0.7;
                    }
                }
            }
        }
        .basic-content {
            display: flex;
                font-size: 12px;
                padding: 16px 26px;
                background: #fff;
                .product {
                    width: 260px;
                    color: #313238;
                    li {
                        margin: 4px 0;
                        display: flex;
                        align-items: center;
                    }
                }
        }
    }
    .va {
        width: 100%;
        height: 29px;
        margin: 24px 0;
        display: block;
        text-align: center;
        font-size: 22px;
        color: #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        .va-icon {
            width: 19.53px;
            height: 19.53px;
            background-image: linear-gradient(225deg, #FFFFFF 0%, #CECECE 100%);
            border-radius: 1px;
            z-index: 20;
            position: relative;
            top: 0;
        }
        .r1 {
            transform: rotate(-135deg);
        }
        .r2 {
            transform: rotate(-315deg);
        }
        .rr {
            z-index: 10;
            left: -10px;
        }
        .ll {
            z-index: 10;
            right: -10px;
        }
    }
    .annotation {
        margin-bottom: 16px;
        font-size: 14px;
        color: #63656e;
        text-align: center;
    }
    .combos {
        width: 1200px;
        // display: flex;
        // flex-wrap: wrap;
        // justify-content: space-between;
        .combo-item {
            background: #fff;
            width: 388px;
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10);
            border-radius: 2px;
            padding-bottom: 17px;
            margin-bottom: 17px;
            float: left;
            margin-right: 18px;
            // width: calc(100%/3 - 20px);
            .combo-name {
                width: 100%;
                height: 68px;
                line-height: 68px;
                font-weight: Bold;
                font-size: 18px;
                color: #313238;
                text-align: center;
                position: relative;
                background-image: linear-gradient(90deg, #F9F9FB 1%, #EFEFF1 72%);
                .combo-tag {
                    position: absolute;
                    width: 61px;
                    height: 51px;
                    top: 0;
                    left: -4px;
                }
            }
            .combo-size {

            }
            .combo-desc {
                display: block;
                margin: 30px 30px 0 30px;
                font-size: 12px;
                color: #63656E;
                line-height: 21px;
            }
            .combo-ctr {
                width: 100%;
                padding: 0 30px;
                height: auto;
            }
            .combo-btns {
                width: 388px;
                display: flex;
                flex-direction: column;
                clear: both;
                .combo-download {
                    width: 260px;
                    height: 32px;
                    color: #fff;
                    background: #3A84FF;
                    border-radius: 2px;
                    margin: 25px auto 12px;
                }
                .combo-install {
                    font-size: 12px;
                    margin: 0 auto;
                    color: #3a84ff;
                    cursor: pointer;
                    text-align: center;
                }
            }
        }
        .combo-item:nth-child(3) {
            margin-right: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// packageDown.vue?4c4a381c